import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { User as BaseUser, SmallBodySemiBold, Flex, OutsourceLogo } from '@ubeya/shared-web/components';
import useSuppliers from '@ubeya/shared/hooks/account/useSuppliers';
import { EMPLOYEE_CLIENT_PREFERENCE_STATUS } from '@ubeya/shared-web/utils/employee';
import PreferredEmployeeButton from '../PreferredEmployeeButton/PreferredEmployeeButton';
import BlockedEmployeeButton from '../BlockedEmployeeButton/BlockedEmployeeButton';

const User = styled(BaseUser)`
  flex: 1;
  .name {
    max-width: 100px;
  }
`;

const Container = styled(Flex)`
  flex: 1;
  align-items: center;
`;

const OriginSupplierLogoWrapper = styled.div`
  position: absolute;
  right: -8px;
  bottom: 1px;

  .out-source-logo-circle,
  .out-source-logo-image {
    border: 1px solid ${({ theme }) => theme.colors.grey3};
    height: 20px;
    width: 20px;
  }
`;

const ExternalNameRenderer = ({
  rowData: {
    employee,
    totalRows,
    summarized,
    shiftId: supplierShiftId,
    isThirdParty,
    originSupplierData,
    supplierAccountId
  },
  columnData: { mappedEmployeesClientStatus, onClick, t, updateOSEmployee }
}) => {
  const { mappedSuppliers } = useSuppliers();
  const [employeeClientStatus, setEmployeeClientStatus] = useState(null);

  const showOriginalSupplierToClient = mappedSuppliers[supplierAccountId]?.crmConfig?.showOriginalSupplierToClient;
  const shouldRenderExternalSupplierName = originSupplierData && showOriginalSupplierToClient;

  const changeStatus = (status) => {
    setEmployeeClientStatus((prev) => {
      const newStatus = prev === status ? null : status;
      updateOSEmployee({ employeeId: employee.id, clientStatus: newStatus });
      return newStatus;
    });
  };

  const toogleStatusPreferred = () => {
    changeStatus(EMPLOYEE_CLIENT_PREFERENCE_STATUS.PREFERRED);
  };
  const toogleStatusBlocked = () => {
    changeStatus(EMPLOYEE_CLIENT_PREFERENCE_STATUS.BLOCKED);
  };

  useEffect(() => {
    setEmployeeClientStatus(mappedEmployeesClientStatus?.[employee?.id]?.status);
  }, [employee?.id, mappedEmployeesClientStatus, mappedEmployeesClientStatus?.employee?.id]);

  if (summarized) {
    return totalRows ? <SmallBodySemiBold>{`${totalRows} ${t('total')}`}</SmallBodySemiBold> : <></>;
  }

  const employeeIsPreferredByClient = employeeClientStatus === EMPLOYEE_CLIENT_PREFERENCE_STATUS.PREFERRED;
  const disableClick = isThirdParty;
  const onEmployeeClick = disableClick ? undefined : () => onClick?.({ ...employee, supplierShiftId });

  return (
    <Container>
      <User
        {...employee}
        onClick={onEmployeeClick}
        withUnderline
        showOnAvatarData={
          shouldRenderExternalSupplierName && (
            <OriginSupplierLogoWrapper>
              <OutsourceLogo logo={originSupplierData.logo} name={originSupplierData.name} />
            </OriginSupplierLogoWrapper>
          )
        }
      />
      {employee && employeeClientStatus === EMPLOYEE_CLIENT_PREFERENCE_STATUS.BLOCKED ? (
        <BlockedEmployeeButton onChange={toogleStatusBlocked} />
      ) : (
        <PreferredEmployeeButton
          onChange={toogleStatusPreferred}
          isPreferred={employeeIsPreferredByClient}
          isThirdParty={!!isThirdParty}
        />
      )}
    </Container>
  );
};

export default ExternalNameRenderer;
